"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SixCircleFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SixCircleFilled = function SixCircleFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F4F9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.184 26.264c-.288-2.64-2.064-4.2-4.728-4.2-3.648 0-5.832 3.12-5.832 8.328 0 5.064 2.016 7.872 5.616 7.872 3.096 0 5.304-2.28 5.304-5.496 0-3.072-1.944-5.136-4.848-5.136-1.537 0-2.713.624-3.577 1.92.024-.168.024-.36.024-.384.264-3.384 1.296-5.04 3.168-5.04 1.345 0 2.136.72 2.377 2.136h2.495zm-4.944 3.408c1.608 0 2.712 1.296 2.712 3.216 0 1.944-1.08 3.24-2.736 3.24-1.657 0-2.76-1.32-2.76-3.288 0-1.968 1.056-3.168 2.784-3.168z",
    fill: "#97BA1E"
  }));
};

exports.SixCircleFilled = SixCircleFilled;
var _default = SixCircleFilled;
exports.default = _default;